module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('modal', {
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Log in")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("login.slogan")))]), _vm._v(" "), _vm._l((_vm.errors), function(error, index) {
    return _c('alert', {
      key: index,
      attrs: {
        "error": error
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.user.email),
      expression: "credentials.user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('login.username'),
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group position-relative"
  }, [((_vm.passowordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.user.password),
      expression: "credentials.user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t('login.password'),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.credentials.user.password) ? _vm._i(_vm.credentials.user.password, null) > -1 : (_vm.credentials.user.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.credentials.user.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.credentials.user, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.credentials.user, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.credentials.user, "password", $$c)
        }
      }
    }
  }) : ((_vm.passowordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.user.password),
      expression: "credentials.user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t('login.password'),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.credentials.user.password, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.credentials.user, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.user.password),
      expression: "credentials.user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t('login.password'),
      "type": _vm.passowordType
    },
    domProps: {
      "value": (_vm.credentials.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visible_toggle"
  }, [(_vm.passowordType === 'password') ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.passowordType = 'text'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/ico_cross_eye.svg"),
      "alt": ""
    }
  })]) : _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.passowordType = 'password'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/ico_eye.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.forgotPassword($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.forgot")))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fbLogin()
      }
    }
  }, [_vm._v("Log in with Facebook")])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.logInButtom")))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c168124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/LoginModal.vue
// module id = 822
// module chunks = 1